import script from "./PortalTeaserBox.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalTeaserBox.vue?vue&type=script&setup=true&lang=js"

import "./PortalTeaserBox.vue?vue&type=style&index=0&id=47362317&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47362317"]])

export default __exports__